import React from "react";
import styled from "styled-components";
import SubscriberThroughputLiveReport from "./Report";
import help from "help/viewSubscriberThroughput.md";
import View from "common/View";

const RedText = styled.span`
  color: var(--signal-red);
`;

const SubscriberThroughputLive = (params) => {
  return (
    <View
      title="Subscriber Throughput Live"
      subtitle={
        <>
          <RedText>Right-click</RedText> on the legend items or inside the
          chart to get the corresponding subscriber dashboard.
        </>
      }
      mdHelp={help}
      returnView={params.returnView}
      backButton={params.showReturn || params.returnView != null}
      refresh={null}
    >
      <div className="body flex-panel-row">
        <SubscriberThroughputLiveReport {...params} />
      </div>
    </View>
  );
};

export default SubscriberThroughputLive;
